import { HStack, Text, VStack } from "@chakra-ui/react";
import { UserFragment } from "gql/graphql";
import { InfoIcon } from "modules/icons";
import React, { memo } from "react";
import colors from "app/colors";
import UserInvite from "./user-invite";
import { isUserSmsOnlyAndNotLoggedIn } from "modules/utils/Functions";

interface IProps {
  user: UserFragment;
}

const UserActive: React.FC<IProps> = ({ user }) => {
  if (!isUserSmsOnlyAndNotLoggedIn(user)) {
    return null;
  }

  return (
    <HStack p={2} alignItems="start" bg={colors.blueLight} borderRadius="4px">
      <InfoIcon boxSize={5} fill={colors.blue} />
      <VStack alignItems="start" gap={0}>
        <Text fontWeight={600} fontSize={14} color={colors.blackSecondary}>
          This user is active on Synco via text/SMS only
        </Text>
        <UserInvite user={user} />
      </VStack>
    </HStack>
  );
};

export default memo(UserActive);
